import React, { useMemo } from 'react';

import { Box, Flex, useTheme } from '@chakra-ui/react';
import useOKRCreationPermissionsBasedOnEmployeeGoalsPrivileges from 'components/hooks/useOKRCreationPermissionsBasedOnEmployeeGoalsPrivileges';

import { PlusNotOutlined } from 'assets/assetsV1/iconComponents';

import { GOAL_PROGRESSES } from 'constants/ProjectConstants';

import { Avatar } from 'uiToolkitV1/Avatar';
import { Button } from 'uiToolkitV1/Button';
import { ListItemComp } from 'uiToolkitV1/ListItemComp';
import { TextBodyMedium, TextLabelSmall } from 'uiToolkitV1/Typography/Typography';

import { COLOR_MAP } from '../Audit/RabbitGoalProgressBar';

const Stats = ({ stats }) => {
  const theme = useTheme();

  const mappedStats = useMemo(
    () =>
      GOAL_PROGRESSES.map((gp) => ({
        key: gp.value,
        title: gp.label,
        count: stats[gp.key],
        color: gp.value === 'CLOSED' ? COLOR_MAP[gp.value]?.barColor : COLOR_MAP[gp.value]?.textColor,
      })),
    [stats]
  );

  return (
    <Flex padding="16px 12px" justifyContent="space-between">
      {mappedStats.map(({ key, title, count, color }) => (
        <Flex key={key} direction="column" alignItems="flex-start" justifyContent="center">
          <TextLabelSmall color={theme.colors.text.g2} bold>
            {title}
          </TextLabelSmall>
          <TextBodyMedium color={color}>{count}</TextBodyMedium>
        </Flex>
      ))}
    </Flex>
  );
};

const CardHeader = ({ employee, stats, createNewHandler, createNewInProgress }) => {
  const theme = useTheme();

  /* Access Control code starts here */
  const { canCreateKeyResultUnderKeyResult, canCreateKeyResultUnderObjective, canCreateKeyResultAtRootLevel } =
    useOKRCreationPermissionsBasedOnEmployeeGoalsPrivileges();

  const canCreateKeyResult =
    canCreateKeyResultAtRootLevel || canCreateKeyResultUnderObjective || canCreateKeyResultUnderKeyResult;

  /* Access Control code ends here */

  return (
    <Box>
      <Box bgColor={theme.colors.surface.F5F7F9} padding="12px 8px" borderRadius="4px" minHeight="64px">
        <ListItemComp
          withoutBackground
          isBoldText={false}
          title={employee?.fullName}
          size="extraLarge"
          LeftComponent={() => <Avatar src={employee.getProfileImage()} />}
          RightComponent={
            canCreateKeyResult ? (
              <Button
                variant="tertiary"
                StartIcon={PlusNotOutlined}
                onClick={createNewHandler}
                disabled={createNewInProgress}
              />
            ) : null
          }
          subTitle={employee?.designation}
        />
      </Box>
    </Box>
  );
};

export default CardHeader;
